export const DISABLED_TOOLTIP = 'Suspected / No recording';
